import { memo } from "react";
import { EdgeLabelRenderer, type EdgeProps } from "@xyflow/react";
import type { HealthMapFlowEdge } from "./healthMapUtils";

export const HealthMapStaticEdge = memo(function HealthMapStaticEdge({
  data,
  id,
  label,
  markerEnd,
  selected,
  sourceX,
  sourceY,
  style,
  targetX,
  targetY
}: EdgeProps<HealthMapFlowEdge>) {
  const stroke = typeof style?.stroke === "string" ? style.stroke : "rgba(136, 160, 152, 0.58)";
  const path = buildStaticPath(sourceX, sourceY, targetX, targetY);
  const labelX = sourceX + (targetX - sourceX) / 2;
  const labelY = sourceY + (targetY - sourceY) / 2;

  return (
    <>
      <path
        className={[
          "react-flow__edge-path",
          "health-flow-edge-path",
          data?.unhealthy ? "unhealthy" : "",
          selected ? "selected" : ""
        ].filter(Boolean).join(" ")}
        d={path}
        id={id}
        markerEnd={markerEnd}
        style={{
          ...style,
          stroke
        }}
      />
      {(label || data?.relationshipLabel) && (
        <EdgeLabelRenderer>
          <div
            className={["health-flow-edge-label", data?.unhealthy ? "unhealthy" : ""].filter(Boolean).join(" ")}
            style={{
              borderColor: data?.unhealthy ? stroke : undefined,
              color: data?.unhealthy ? stroke : undefined,
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`
            }}
          >
            {label || data?.relationshipLabel}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
});

function buildStaticPath(sourceX: number, sourceY: number, targetX: number, targetY: number): string {
  const deltaX = targetX - sourceX;
  const deltaY = targetY - sourceY;
  const controlX1 = sourceX + deltaX * 0.34;
  const controlY1 = sourceY + deltaY * 0.18;
  const controlX2 = targetX - deltaX * 0.34;
  const controlY2 = targetY - deltaY * 0.18;

  return `M ${sourceX} ${sourceY} C ${controlX1} ${controlY1}, ${controlX2} ${controlY2}, ${targetX} ${targetY}`;
}
